import React from 'react';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../types/shared/UUID';
import { useAppDispatch } from '../../../store/store';
import { useKeyToSelect } from '../../../store/createKeyedDataAsyncSlice';
import { RootStore } from '../../../store/types';
import { ErrorMessage } from '../../../ui-toolkit';
import { isLoanAmountEditable } from '../../../utilities/clientPortal/isLoanAmountEditable';
import {
  updateClientLoanAmountSlice,
  updateClientLoanUpdateAccountAction,
} from '../../../store/clientPortal/clientOrderLoanAmountUpdateSlice';
import { ClientSummaryBlock } from '../../../components/clientPortal/orderOverview/ClientSummaryBlock';
import { getClientOrderAction } from '../../../store/clientPortal/clientOrderSlice';
import { updateClientSlice, updateClientUpdateAction } from '../../../store/clientPortal/clientOrderUpdateSlice';

export const ClientSigningContainer: React.FC = () => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const dispatch = useAppDispatch();

  const { data: orderData, fetchError: orderFetchError } = useKeyToSelect(
    orderId,
    ({ clientPortal }: RootStore) => clientPortal.clientOrder
  );

  const { fetchError: updateLoanAmountFetchError, fetchStatus: updateLoanAmountFetchStatus } = useKeyToSelect(
    orderId,
    ({ clientPortal }: RootStore) => clientPortal.clientLoanAmount
  );

  const isEditable = isLoanAmountEditable(orderData);

  const onLoanAmountUpdate = async (loanAmount: number | null) => {
    if (isEditable) {
      await dispatch(updateClientLoanUpdateAccountAction({ orderId, loanAmount }));
      await dispatch(getClientOrderAction(orderId));
    }
  };
  const onUpdateEmployerName = async (value?: string | null) => {
    await dispatch(
      updateClientUpdateAction({
        id: orderId,
        order: { ...orderData!, relocationEmployerName: value || undefined },
      })
    );
    await dispatch(getClientOrderAction(orderId));
    dispatch(updateClientSlice.actions.reset({}));
  };

  const onCleanLoanAmountForm = () => {
    dispatch(updateClientLoanAmountSlice.actions.resetByKey(orderId));
  };

  return (
    <>
      <ErrorMessage error={orderFetchError || updateLoanAmountFetchError} />
      {orderData && (
        <ClientSummaryBlock
          order={orderData}
          onLoanAmountUpdate={onLoanAmountUpdate}
          editLoanAmountFetchStatus={updateLoanAmountFetchStatus}
          onResetLoanAmountUpdates={onCleanLoanAmountForm}
          isLoanAmountEditable={isEditable}
          onUpdateEmployerName={onUpdateEmployerName}
        />
      )}
    </>
  );
};
